export default "__VITE_ASSET__fHBMVAEd__"